// extracted by mini-css-extract-plugin
export default {"horizontalLine":"AccountVerificationModal_horizontalLine__psvn6","wrap":"AccountVerificationModal_wrap__hp3k0"};